// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Wijw","buttons":"Footer_buttons__1u4yg"};